<template>
  <div class="login">
		<backgroundone v-slot:backgroundslot>
			<loginitem>
			</loginitem>
		</backgroundone>
  </div>
</template>

<script>
	
	import backgroundone from '../components/background/backgroundone.vue'
	import loginitem from '../components/loginbox/loginitem.vue'
	
	export default {
	  name: 'Login',
		components:{
			backgroundone,
			loginitem
		}
	}
</script>

<style>
	
</style>